export { InputV2 as default, InputBaseV2 } from './Input';
